export const SET_EMAIL_IS_VALID = 'SET_EMAIL_IS_VALID';
export const SET_PHONE_IS_VALID = 'SET_PHONE_IS_VALID';